import './../assets/css/style.scss';
import React, { useEffect } from 'react';
import { navigate } from 'gatsby-link';
import { Store } from '../helpers/redux/StoreContainer';
import Actions from './../helpers/actions/ActionWrapper';
import { DashboardConstants } from '../helpers/constants/Props/DashboardPageConstants';
import { LoginConstants } from '../helpers/constants/Props/LoginPageConstants';
import { LoginManager } from '../helpers/api/core/LoginManager';
import BackgroundStatic from '../components/background-component-group/background-static/BackgroundStatic';
import { LoggingService } from '../helpers/services/log';
import { SecurityService } from '../helpers/services/security';
import { HammerService } from '../helpers/services/imports/Hammer';
import { EnableControlVersion } from '../helpers/services/react';
import { EnvironmentVariables } from '../helpers/constants/EnvironmentVariables';

const Index = () => {
  LoggingService.init();
  HammerService.init();
  const store = Store;
  store.dispatch(Actions.Page.Dashboard.propsSent(DashboardConstants));
  store.dispatch(Actions.Page.Login.propsSent(LoginConstants));


  useEffect(() => {
    async function Startup() {
      const isSecurityBreached = await SecurityService.onStartupControl();
      if (isSecurityBreached) {
        return <BackgroundStatic></BackgroundStatic>;
      } else if (LoginManager.IsLoginNeeded()) {
        navigate('/login');
      } else {
        navigate('/dashboard');
      }
      if (EnvironmentVariables.Is_Mobile) {
        EnableControlVersion();
      }
    }
    Startup();
  }, []);

  return <BackgroundStatic></BackgroundStatic>;
};

export default Index;
